import IconCircleInfo from 'central-icons/IconCircleInfo';
import { components, type OptionProps } from 'react-select';

import {
  CheckboxIndicator,
  RevelioTooltip,
  ThemedCheckboxIcon,
} from '@revelio/ui';

import { AdminIdChip } from '../AdminIdChip/AdminIdChip';
import styles from './option.module.css';
import type { Option } from './SelectionListSelect';

export const CustomOption = <IsMulti extends boolean = true>(
  props: OptionProps<Option, IsMulti>
) => {
  return (
    <components.Option {...props}>
      <div
        className={styles.selectionTreeDataNode}
        data-testid="selection-tree-data-node"
        data-option-value={props.data.value}
        data-option-label={props.data.label}
        data-disabled={props.isDisabled || undefined}
      >
        <div className={styles.rowContent}>
          {/* The indicator alone, not the full `Checkbox`: that one wraps its
              input in a <label>, and inside a react-select option the label
              would forward a second click to the row and undo the toggle. The
              hidden input stays for assistive tech and the Playwright helpers
              that locate rows through it. */}
          <div className={styles.checkboxWrapper}>
            <input
              className={styles.checkbox}
              type="checkbox"
              checked={props.isSelected}
              disabled={props.isDisabled}
              onChange={() => null}
            />
            <CheckboxIndicator
              checked={props.isSelected}
              disabled={props.isDisabled}
            >
              <ThemedCheckboxIcon isChecked={props.isSelected} />
            </CheckboxIndicator>
          </div>
          <label className={styles.label}>{props.label}</label>
          {props.data.info && (
            <RevelioTooltip
              label={props.data.info}
              placement="right"
              maxWidth={330}
              className={styles.infoTooltip}
              triggerClassName={styles.infoTooltipTrigger}
            >
              <span className={styles.infoIcon}>
                <IconCircleInfo size={14} color="#96a0b5" cursor="pointer" />
              </span>
            </RevelioTooltip>
          )}
        </div>
        <AdminIdChip entityId={props.data.value} />
      </div>
    </components.Option>
  );
};
